import { gql } from '@/__generated__';

export const GET_USER_NAME = gql(`#graphql
  query GetUserName($id: Int) {
    user(id: $id) {
      id
      fullName
    }
  }
`);
